"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TagEntityType = exports.ChannelTagType = void 0;
var ChannelTagType;
(function (ChannelTagType) {
    ChannelTagType["CareCandidate"] = "CareCandidate";
    ChannelTagType["CareCreditCandidate"] = "CareCreditCandidate";
    ChannelTagType["Custom"] = "Custom";
    ChannelTagType["FormRequested"] = "FormRequested";
    ChannelTagType["FormSubmitted"] = "FormSubmitted";
    ChannelTagType["HillsDietIssue"] = "HillsDietIssue";
    ChannelTagType["HillsIDPurchaseRequest"] = "HillsIDPurchaseRequest";
    ChannelTagType["PaymentReceived"] = "PaymentReceived";
    ChannelTagType["PaymentRequested"] = "PaymentRequested";
    ChannelTagType["SwitchingVets"] = "SwitchingVets";
    ChannelTagType["TrupanionCandidate"] = "TrupanionCandidate";
    ChannelTagType["NewClient"] = "NewClient";
})(ChannelTagType = exports.ChannelTagType || (exports.ChannelTagType = {}));
var TagEntityType;
(function (TagEntityType) {
    TagEntityType["FormSubmission"] = "FormSubmission";
    TagEntityType["ClinicPet"] = "ClinicPet";
})(TagEntityType = exports.TagEntityType || (exports.TagEntityType = {}));
//# sourceMappingURL=ChannelTag.js.map